import {
    getReportPreviewCatalog, getReportPreviewFolders, getReportPreviewDetails,
    createReportPreview, getReportPreviewGrid, getReportPreviewGridPage, downloadReportPreview,
    generateReportConfigurationExcludedRecordsWorkbook,
} from "../../../../service/httpsCalls";
import type { PreviewArtifact, PreviewCatalog, PreviewFilters, PreviewFolder, PreviewGrid, PreviewGridSection, PreviewReportDetails } from "../types";

export const loadCatalog = (filters: PreviewFilters, signal: AbortSignal): Promise<PreviewCatalog> =>
    getReportPreviewCatalog({ ...filters, clientId: filters.clientId || undefined, folderId: filters.folderId || undefined,
        effectiveFrom: filters.effectiveFrom || undefined, effectiveTo: filters.effectiveTo || undefined }, signal);
export const loadFolders = (signal: AbortSignal): Promise<PreviewFolder[]> => getReportPreviewFolders(signal);
export const loadReport = (id: number, signal: AbortSignal): Promise<PreviewReportDetails> => getReportPreviewDetails(id, signal);
export const generatePreview = (reportId: number, signal: AbortSignal): Promise<PreviewArtifact> =>
    createReportPreview(reportId, signal);
export const loadGrid = (id: string, index: number, signal: AbortSignal): Promise<PreviewGrid> => getReportPreviewGrid(id, index, signal);
export const downloadWorkbook = (id: string, signal: AbortSignal): Promise<Blob> => downloadReportPreview(id, signal);
export const downloadExcludedRecordsWorkbook = (reportId: number, configVersionId: number) =>
    generateReportConfigurationExcludedRecordsWorkbook(reportId, configVersionId);

export async function previewError(error: unknown): Promise<string> {
    const response = (error as { response?: { status: number; data: unknown } })?.response;
    if (response?.status === 401) return "Your session has expired. Sign in again to view reports.";
    if (response?.status === 403) return "You do not have permission to view these reports.";
    if (response?.status === 410) return "This preview has expired. Refresh the report to generate it again.";
    let data = response?.data;
    if (data instanceof Blob) data = await data.text();
    if (typeof data === "string") {
        const text = data;
        try { data = JSON.parse(text); } catch { return text.slice(0, 500); }
    }
    const message = (data as { message?: string; title?: string })?.message || (data as { title?: string })?.title;
    return message || "The report request failed. Please retry.";
}

export const loadGridPage = (id: string, index: number, section: number, page: number, pageSize: number, signal: AbortSignal): Promise<PreviewGridSection> =>
    getReportPreviewGridPage(id, index, section, page, pageSize, signal);
